import type { VoidFunctionComponent } from 'react';
import Button from '../../../generic/Button';
import { FormGroup, LabeledTextInput } from '../../../generic/Forms';
import type { MavenServer } from '../../../../../typings/common';

type ServerProps = Pick<MavenServer, 'id' | 'username' | 'password' | 'hasPassword'> & {
  onUpdateServer: <K extends keyof MavenServer>(
    member: K,
    value: MavenServer[K],
  ) => void;
  onRemove: () => void;
};

/**
 * Maven settings Server row.
 */
const Server: VoidFunctionComponent<ServerProps> = ({
  id,
  username,
  password,
  hasPassword,
  onUpdateServer,
  onRemove,
}) => (
  <div className="margin-bottom-sm">
    <FormGroup direction="row" spacing="sm" baselineAlignment>
      <LabeledTextInput
        label="ID"
        value={id || ''}
        size="small"
        onChange={value => onUpdateServer('id', value)}
        placeholder="foo"
      />
      <LabeledTextInput
        label="Username"
        value={username || ''}
        size="small"
        onChange={value => onUpdateServer('username', value)}
        placeholder="foo"
      />
      <LabeledTextInput
        label="Password"
        value={hasPassword ? '••••••••' : password?.value || ''}
        size="small"
        onChange={value => {
          // We store passwords and sensitive data as a FetcherConfigSecret (typings/auth.d.ts)
          onUpdateServer(
            'password',
            {
              __type: 's',
              value,
            },
          );
        }}
        placeholder="••••••••"
      />
      <Button
        type="error"
        size="small"
        onClick={onRemove}
      >
        Remove
      </Button>
    </FormGroup>
  </div>
);

export default Server;
